import React from 'react'
import FacilityList from '../../features/admin/FacilityList'

const FacilityListPage = () => {
  return <FacilityList/>
}

export default FacilityListPage